export default __webpack_public_path__ + "static/media/logoBoulevard.0d42d0b5.png";